module.exports = __webpack_public_path__ + "static/media/Duke_University.b0633387.png";